import type { ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { States } from '../../../constants';
import type { RootState } from '../../../store';
import { set } from '../../../store/Opportunity/BasicInfo';

function FormOpportunityInfo() {
  const dispatch = useDispatch();
  const opportunityInfoState = useSelector((state: RootState) => state.opportunity.opportunityInfo);
  const projectType = [
    'Single Family',
    'Small Multi-Family',
    'Duplex',
    'Retail - Office',
    'Retail - Restaurant',
    'Retail - Medical',
    'Retail - Traditional',
    'Maintenance Facility',
    'Recreation Center',
    'Office',
    'School',
    'Mixed-Use',
  ];
  const constructionType = ['New Construction', 'Renovation', 'Historic Renovation', 'Interior Fitout'];

  const procurementType = ['Off-Market', 'On-Market'];

  const changeHandler = (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
    dispatch(set({ [e.target.name]: e.target.value }));
  };

  return (
    <>
      <h2 className='mt-0 text-primaryColor-normal'>Baseline Opportunity Information</h2>
      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>
          Project Name<sup>*</sup>
        </label>
        <input type='text' name='projectName' value={opportunityInfoState.projectName} className='form-input' onChange={changeHandler} />
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>
          Address<sup>*</sup>
        </label>

        <input type='text' name='address' value={opportunityInfoState.address} className='form-input' onChange={changeHandler} />
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>Market</label>
        <select className='form-input px-2 py-2 appearance-none' name='market' value={opportunityInfoState.market} onChange={changeHandler}>
          <option value='' disabled selected>
            Select Market
          </option>
          {States.map((s) => (
            <option key={s.name} value={s.name}>
              {s.name}
            </option>
          ))}
        </select>
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>Sub-market</label>
        <input type='text' name='subMarket' value={opportunityInfoState.subMarket} className='form-input' onChange={changeHandler} />
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>Project Type</label>
        <select
          className='form-input px-2 py-2 appearance-none'
          name='projectType'
          value={opportunityInfoState.projectType}
          onChange={changeHandler}
        >
          <option value='' disabled selected>
            Select Project Type
          </option>
          {projectType.map((val) => (
            <option key={val} value={val}>
              {val}
            </option>
          ))}
        </select>
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>Construction Type</label>
        <select
          className='form-input px-2 py-2 appearance-none'
          name='constructionType'
          value={opportunityInfoState.constructionType}
          onChange={changeHandler}
        >
          <option value='' disabled selected>
            Select Construction Type
          </option>
          {constructionType.map((val) => (
            <option key={val} value={val}>
              {val}
            </option>
          ))}
        </select>
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>Procurement Type</label>
        <select
          className='form-input px-2 py-2 appearance-none'
          name='procurementType'
          value={opportunityInfoState.procurementType}
          onChange={changeHandler}
        >
          <option value='' disabled selected>
            Select Procurement Type
          </option>
          {procurementType.map((val) => (
            <option key={val} value={val}>
              {val}
            </option>
          ))}
        </select>
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>Sourcing Document</label>
        <input
          type='text'
          name='sourcingDocument'
          value={opportunityInfoState.sourcingDocument}
          className='form-input'
          onChange={changeHandler}
        />
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>Development Partner</label>
        <input
          type='text'
          name='developmentPartner'
          value={opportunityInfoState.developmentPartner}
          className='form-input'
          onChange={changeHandler}
        />
      </div>
      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>
          Square Feet<sup>*</sup>
        </label>

        <input type='number' name='squareFeet' value={opportunityInfoState.squareFeet} className='form-input' onChange={changeHandler} />
      </div>
    </>
  );
}

export default FormOpportunityInfo;
